import { LinkItem } from "Interfaces/general.interface";

import CustomLinkButton from "GeneralComponents/CustomLinkButton";
import { useState } from "react";
import Helper from "Interfaces/Helper";
import Consts from "Interfaces/Consts";

interface Props {
    id: string;
    hasCollapseBtn: boolean;
    hasLinkBtn: boolean;
    title: string;
    dir: string;
    linkBtn: LinkItem;
    isBtnCentered: boolean;
    isTextHolderWithBG: boolean;
};

const TextHolderBoxButton: React.FC<Props> = ({ hasCollapseBtn, hasLinkBtn, dir, id, isBtnCentered, linkBtn, title, isTextHolderWithBG, }) => {


    if (!hasCollapseBtn && !hasLinkBtn) return null;


    return <div className={`${isBtnCentered? "mx-auto mst-center-justfy-text mst-print-hide": ''}`}>

        {
            hasCollapseBtn &&

            <CollapseButton
                title={title}
                target={"collapseAbout-" + id}
                focusOnClick={"whrapper-collapseAbout-" + id}
                btnClass="mst-btn mst-collapse-btn"
                dir={dir}
            />
        }

        {
            hasLinkBtn && 

            <CustomLinkButton
                title={linkBtn.title.trim()}
                pageUrl={""}
                link={linkBtn}
                isBtn={true}
                btnClass={"mst-btn mst-collapse-btn px-3 px-md-5 btn-dynamicTextHolder"}
                linkClass={""}
                dir={dir}
                linkIcon={false}
                charLimit={isTextHolderWithBG ? 25 : 40}
            />
        }

    </div>

}

type CollapseButtonProps = {
    title: string;
    target: string;
    focusOnClick: string;
    btnClass: string;
    txtOpen?: string;
    txtClose?: string;
    dir: string;
};

const CollapseButton: React.FC<CollapseButtonProps> = ({ txtClose = Consts.close, txtOpen = Consts.readMore, btnClass, dir, focusOnClick, target, title }) => {

    const [isCollapsed, setIsCollapsed] = useState(true);

    const setFocus = () => {

        if (focusOnClick && isCollapsed) {
            const wrapper = document.getElementById(focusOnClick);
            wrapper.style.outlineStyle = "none";
            wrapper.tabIndex = 0;
            wrapper.focus();
            wrapper.tabIndex = -1;
            Helper.handleLinkClicksGA4("Text Holder", title, "read more");
        }

        setIsCollapsed(prev => !prev);
    }


    return (

        <button type="button" data-toggle="collapse"
            data-target={"#" + target} aria-expanded="false" aria-controls={target}
            className={btnClass}
            onClick={setFocus}>

            <span>{txtClose} <i className="fa fa-fw fa-chevron-up" aria-hidden="true"></i></span>
            <b aria-hidden="true">{txtOpen} <i className={`fa-chevron-${dir == 'rtl'? 'left': 'right'} fa fa-fw align-middle`} aria-hidden="true"></i></b>
            <b className="txt-invisible">{Consts.readMoreAbout}{title}</b>

        </button>
    );

}


export default TextHolderBoxButton;